import { css } from '@emotion/react';

export const globalStyles = css`
  html {
    font-size: 4vw;
    @media (orientation: landscape) {
      font-size: 2vw;
    }
  }
  .ant-select-item,
  .next-menu-item-inner,
  .ant-picker-month-panel,
  .ant-picker-panel-container {
    font-size: 3.6vw !important;
    line-height: inherit !important;
    height: auto !important;
    @media (orientation: landscape) {
      font-size: 1.8vw !important;
    }
  }
  .ant-select-arrow {
    font-size: inherit !important;
  }
  .ant-picker-cell .ant-picker-cell-inner {
    height: auto !important;
    line-height: inherit !important;
    width: auto;
  }
  .ant-picker-content td {
    padding: 0 10px;
  }
  .ant-picker-decade-panel,
  .ant-picker-date-panel,
  .ant-picker-month-panel,
  .ant-picker-content,
  .ant-picker-year-panel {
    width: auto !important;
  }
  .ant-image-preview-mask {
    background: black;
  }
  .ant-image-preview-operations {
    background: rgba(0, 0, 0, 0.5);
    & > *:not(:first-of-type, :nth-of-type(2)) {
      display: none;
    }
  }
  .ant-image-preview-operations-progress {
    top: 1rem;
  }
  .anticon-close {
    & > svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;
